export enum Size {
  LARGE,
  SMALL,
  MEDIUM,
  XSMALL,
  XLARGE,
}
